<div id="mainBody" [ngClass]="{ slideOutShowMenu: navbarOpen(), slideInHideMenu: !navbarOpen() }">
  <app-header
    [user]="user()"
    [navbarOpen]="navbarOpen()"
    (toggleMenu)="toggleMenu()"
    (toggleLogin)="showModal(login)"
    (toggleLogout)="logout()"
  ></app-header>
  <router-outlet></router-outlet>
  <app-footer></app-footer>
</div>
<app-nav-right id="rightMenu" [user]="user()" (toggleLogout)="logout()" (close)="toggleMenu()"> </app-nav-right>
<ng-template #login>
  <app-login-modal (emailSuccess)="hide(); showModal(emailSuccess)" (registerSuccess)="hide(); showModal(registerSuccess)"></app-login-modal>
</ng-template>

<ng-template #registerSuccess>
  <div class="modal-header pb-0 border-0">
    <div class="modal-title page-title eyebrow">
      <h1>Success!</h1>
      <div class="brown-bar"></div>
    </div>
  </div>
  <div class="modal-body">
    <div class="container-fluid">
      <p>Thank you for creating an account. You are now able to create your box and save any progress made.</p>
    </div>
    <div class="button-container">
      <button type="button" class="white-submit" (click)="hide()">OK</button>
    </div>
  </div>
</ng-template>
<ng-template #emailSuccess>
  <div class="modal-header pb-0 border-0">
    <div class="modal-title page-title eyebrow">
      <h1>Success!</h1>
      <div class="brown-bar"></div>
    </div>
  </div>
  <div class="modal-body">
    <div class="container-fluid">
      <p>If a matching account was found an email was sent to reset your password.</p>
    </div>
    <div class="button-container">
      <button type="button" class="white-submit" (click)="hide()">OK</button>
    </div>
  </div>
</ng-template>
